module.exports = __webpack_public_path__ + "media/images/flags/cu-2bdff0723e9a0bc1e2215341c09e299c.svg";